package org.maplibre.compose.interaction.internal

import org.maplibre.compose.interaction.BearingHapticNotch
import org.maplibre.compose.interaction.BearingSnapping
import org.maplibre.compose.interaction.BearingTargets
import org.maplibre.compose.interaction.HapticEmphasis

internal enum class CameraComponent {
  Pan,
  Zoom,
  Rotate,
  Pitch,
}

internal data class CameraConfiguration(
  val settings: CameraSettings = CameraSettings(),
  val onStart: Map<CameraComponent, () -> Unit> = emptyMap(),
)

internal data class CameraSettings(
  val pan: PanCameraConfiguration = PanCameraConfiguration(),
  val zoom: VelocityCameraConfiguration = VelocityCameraConfiguration(),
  val rotate: RotateCameraConfiguration = RotateCameraConfiguration(),
  val pitch: PitchCameraConfiguration = PitchCameraConfiguration(),
) {
  fun enabled(component: CameraComponent): Boolean =
    when (component) {
      CameraComponent.Pan -> pan.enabled
      CameraComponent.Zoom -> zoom.enabled
      CameraComponent.Rotate -> rotate.enabled
      CameraComponent.Pitch -> pitch.enabled
    }
}

internal data class PanCameraConfiguration(
  val enabled: Boolean = true,
  val momentum: PanMomentum = PanMomentum(),
)

internal data class VelocityCameraConfiguration(
  val enabled: Boolean = true,
  val momentum: VelocityMomentum = VelocityMomentum(),
)

internal data class PitchCameraConfiguration(
  val enabled: Boolean = true,
  val momentum: PitchMomentum = PitchMomentum(),
)

internal data class RotateCameraConfiguration(
  val enabled: Boolean = true,
  val momentum: VelocityMomentum = VelocityMomentum(),
  val snapping: BearingSnapping = BearingSnapping(),
  val haptics: List<BearingHapticNotch> =
    listOf(BearingHapticNotch(BearingTargets.at(0.0), HapticEmphasis.Standard)),
)
